import { useEffect, useState } from 'react'

export function useDynamicJs(src: string): boolean {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const id = `dynamic-js-${src}`
    if (document.getElementById(id)) {
      setLoaded(true)
      return
    }

    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = true
    script.onload = () => setLoaded(true)
    script.onerror = () => setLoaded(false)

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [src])

  return loaded
}
